<template>
    <div id="product-wholesaler-sizes"
         class="d-flex flex-spaced-fixed"
         v-if="sizesQuantities">
        <SelectField
                v-model="selectedPhoneModel"
                label="Marca:" v-if="isPhone"
                class="flex-child-fixed">
            <option :value="null">
                Selecione a marca
            </option>
            <option v-for="model in phoneModels" :value="model">
                {{model}}
            </option>
        </SelectField>
        <SelectField
                v-model="selectedSize"
                :label="isPhone ? 'Modelo:' : ''"
                :disabled="isPhone && !selectedPhoneModel"
                class="flex-child-fixed">
            <option v-if="isPhone" :value="null">
                Selecione seu aparelho
            </option>
            <option v-else :value="null">
                Selecione o tamanho
            </option>
            <option v-for="item in selectOptions" :value="item"
                    :disabled="isSizeDisabled(item)">
                {{item.size_name}}
                <span v-if="! product.in_stock || (!item.virtual_stock && item.quantity === 0)">&nbsp;-&nbsp;Esgotado</span>
                <span v-else>&nbsp;- {{getItemProductionType(item)}}</span>
                <span v-if="product.price_min > 0">
                    &nbsp;-&nbsp;
                    <span v-if="item.price_old">De {{item.price_old|formatMoney}} Por</span>
                    <span v-if="item.price">{{item.price|formatMoney}}</span>
                    <span v-else>{{product.price_old|formatMoney}}</span>
                </span>
            </option>
        </SelectField>

        <div v-if="selectedSize" class="form-group flex-child-fixed">
            <label>Quantidade:</label>
            <ProductWholesalerSizeField
                    v-model="sizesQuantities[selectedSize.variation_id]"
                    :product="product"
                    :size="selectedSize"/>
        </div>
    </div>
</template>

<script>
    import ProductWholesalerSizes from "./ProductWholesalerSizes";
    import ProductWholesalerSizeField from "./wholesaler/ProductWholesalerSizeField";
    import SelectField from "@bit/chicorei.chicomponents.input.select-field";
    import NumberField from "@bit/chicorei.chicomponents.input.number-field";

    export default {
        extends: ProductWholesalerSizes,

        name: "ProductWholesalerSingleSize",

        components: {ProductWholesalerSizeField, NumberField, SelectField},

        data() {
            return {
                selectedSize: null
            }
        },

        watch: {
            selectedPhoneModel() {
                if (this.isPhone) {
                    this.selectedSize = null;
                }
            },

            selectedSize() {
                for (let variationId in this.sizesQuantities) {
                    if (this.sizesQuantities.hasOwnProperty(variationId)) {
                        this.sizesQuantities[variationId] = 0;
                    }
                }
            },
        },

        methods: {
            isSizeDisabled(size) {
                return !this.product.in_stock || (size.quantity === 0 && !size.virtual_stock);
            }
        }
    }
</script>